import MOLocation from "../../util/MOLocation"

const useQuery = () => {
  const queryObj = MOLocation.getQueryParams()
  return queryObj
}

export default useQuery
